import { Jodit } from 'jodit-react';

export const sanitizeHtml = (html: string): string => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  Jodit.modules.Helpers.sanitizeHTMLElement(doc.body);
  return doc.body.innerHTML;
};
